import {CompaniesAPI} from 'api/companies';
import {PillTag} from 'components/system/pilltag';
import {PillTagGroup} from 'components/system/pilltag_group';
import {Spinner} from 'components/system/spinner';
import {useEffect, useMemo, useState} from 'react';
import {useAuth, useUpsell} from 'users';

export const TopCompanies = ({config, maxVisible, onConfigChange, companyFilter}: Props) => {
  const {hasPermission} = useAuth();
  const {showUpsellModal} = useUpsell();
  const [loading, setLoading] = useState(true);
  const [companies, setCompanies] = useState<Company[]>([]);

  useEffect(() => {
    const getTopCompanies = async () => {
      const companies = await CompaniesAPI.getTopCompanies();
      setCompanies(companies);
      setLoading(false);
    };
    getTopCompanies();
  }, []);

  const visibleCompanies = useMemo(() => {
    return companies
      .filter((company) => {
        return !companyFilter || company.name.toLowerCase().includes(companyFilter.toLowerCase());
      })
      .slice(0, maxVisible);
  }, [companies, maxVisible, companyFilter]);

  if (loading) return <Spinner size='sm' text='Loading top companies' />;
  if (visibleCompanies.length === 0) return <div>No companies found.</div>;

  return (
    <PillTagGroup>
      {visibleCompanies.map((company) => {
        const selected = config.companies.includes(company.name);

        const addCompany = () => {
          onConfigChange({
            ...config,
            companies: [...config.companies, company.name],
            page: 0,
          });
        };

        const removeCompany = () => {
          onConfigChange({
            ...config,
            companies: config.companies.filter((c) => c !== company.name),
            page: 0,
          });
        };

        const handleClick = () => {
          if (hasPermission('question_company_filter')) {
            if (selected) removeCompany();
            else addCompany();
          } else {
            showUpsellModal({cta: 'question.viewCompanies'});
          }
        };

        return (
          <PillTag key={company.name} color={selected ? 'blue' : 'greyLight'} onClick={handleClick}>
            {company.name}
          </PillTag>
        );
      })}
    </PillTagGroup>
  );
};

type Props = {
  config: QuestionListConfig;
  maxVisible?: number;
  companyFilter: string;
  onConfigChange: (config: QuestionListConfig) => void;
};
